// Backgrounds / Black
export const black = "#050505";

// Transparents / Black / 00-Black-Light (70%)
export const blackLight = "rgba(5,5,5,0.7)";

// Transparents / Black / 01-Black-Xlight (40%)
export const blackXLight = "rgba(5,5,5,0.4)";

// Transparents / Black / 02-Black-Xxlight (10%)
export const blackXXLight = "rgba(5,5,5,0.1)";

// Backgrounds / Blue / Blue-00 (Xxdark)
export const blue00 = "#00101f";

// Backgrounds / Blue / Blue-01
export const blue01 = "#05192b";

// Backgrounds / Blue / Blue-02
export const blue02 = "#092743";

// Backgrounds / Blue / Blue-03 (Xdark)
export const blue03 = "#0d365c";

// Backgrounds / Blue / Blue-04
export const blue04 = "#12487a";

// Backgrounds / Blue / Blue-05 (Dark)
export const blue05 = "#165b99";

// Backgrounds / Blue / Blue-06
export const blue06 = "#1b6fb9";

// Backgrounds / Blue / -Blue-07 (Base)
export const blue07 = "#1f83db";

// Backgrounds / Blue / Blue-08
export const blue08 = "#5995e1";

// Backgrounds / Blue / Blue-09 (Light)
export const blue09 = "#7ea7e7";

// Backgrounds / Blue / Blue-10
export const blue10 = "#9dbaec";

// Backgrounds / Blue / Blue-11 (Xlight)
export const blue11 = "#bacdf2";

// Backgrounds / Blue / Blue-12
export const blue12 = "#d2def6";

// Backgrounds / Blue / Blue-13
export const blue13 = "#eaf0fb";

// Backgrounds / Blue / Blue-14 (Xxlight)
export const blue14 = "#f7fafd";

// Backgrounds / Blue / Blue-15
export const blue15 = "#1976D2";

// Transparents / Blue / 01-Blue-Xlight (40%)
export const blueXLight = "rgba(31,131,219,0.4)";

// Transparents / Blue / 02-Blue-Xxlight (10%)
export const blueXXLight = "rgba(31,131,219,0.1)";

// Backgrounds / Cyan / Cyan-00 (Xxdark)
export const cyan00 = "#001b1e";

// Backgrounds / Cyan / Cyan-01
export const cyan01 = "#042529";

// Backgrounds / Cyan / Cyan-02
export const cyan02 = "#08373d";

// Backgrounds / Cyan / Cyan-03 (Xdark)
export const cyan03 = "#0f4a52";

// Backgrounds / Cyan / Cyan-04
export const cyan04 = "#17616c";

// Backgrounds / Cyan / Cyan-05 (Dark)
export const cyan05 = "#207986";

// Backgrounds / Cyan / Cyan-06
export const cyan06 = "#2991a2";

// Backgrounds / Cyan / -Cyan-07 (Base)
export const cyan07 = "#32abbe";

// Backgrounds / Cyan / Cyan-08
export const cyan08 = "#5fb8c8";

// Backgrounds / Cyan / Cyan-09 (Light)
export const cyan09 = "#80c5d2";

// Backgrounds / Cyan / Cyan-10
export const cyan10 = "#9ed2dc";

// Backgrounds / Cyan / Cyan-11 (Xlight)
export const cyan11 = "#badfe6";

// Backgrounds / Cyan / Cyan-12
export const cyan12 = "#d2eaef";

// Backgrounds / Cyan / Cyan-13
export const cyan13 = "#eaf5f8";

// Backgrounds / Cyan / Cyan-14 (Xxlight)
export const cyan14 = "#f7fcfd";

// Transparents / Cyan / 00-Cyan-Light (70%)
export const cyanLight = "rgba(50,171,190,0.7)";

// Transparents / Cyan / 01-Cyan-Xlight (40%)
export const cyanXLight = "rgba(50,171,190,0.4)";

// Transparents / Cyan / 02-Cyan-Xxlight (10%)
export const cyanXXLight = "rgba(50,171,190,0.1)";

// Backgrounds / Grape / Grape-00 (Xxdark)
export const grape00 = "#18001f";

// Backgrounds / Grape / Grape-01
export const grape01 = "#200b2a";

// Backgrounds / Grape / Grape-02
export const grape02 = "#33143f";

// Backgrounds / Grape / Grape-03 (Xdark)
export const grape03 = "#481d56";

// Backgrounds / Grape / Grape-04
export const grape04 = "#602871";

// Backgrounds / Grape / Grape-05 (Dark)
export const grape05 = "#7a338d";

// Backgrounds / Grape / Grape-06
export const grape06 = "#943eab";

// Backgrounds / Grape / -Grape-07 (Base)
export const grape07 = "#b04ac9";

// Backgrounds / Grape / Grape-08
export const grape08 = "#be68d2";

// Backgrounds / Grape / Grape-09 (Light)
export const grape09 = "#cb84da";

// Backgrounds / Grape / Grape-10
export const grape10 = "#d89fe3";

// Backgrounds / Grape / Grape-11 (Xlight)
export const grape11 = "#e4baeb";

// Backgrounds / Grape / Grape-12
export const grape12 = "#edd2f2";

// Backgrounds / Grape / Grape-13
export const grape13 = "#f7e9f9";

// Backgrounds / Grape / Grape-14 (Xxlight)
export const grape14 = "#fcf7fd";

// Transparents / Grape / 00-Grape-Light (70%)
export const grapeLight = "rgba(176,74,201,0.7)";

// Transparents / Grape / 01-Grape-Xlight (40%)
export const grapeXLight = "rgba(176,74,201,0.4)";

// Transparents / Grape / 02-Grape-Xxlight (10%)
export const grapeXXLight = "rgba(176,74,201,0.1)";

// Backgrounds / Gray / Gray-00 (Xxdark)
export const gray00 = "#0f0f0f";

// Backgrounds / Gray / Gray-01
export const gray01 = "#181818";

// Backgrounds / Gray / Gray-02
export const gray02 = "#242424";

// Backgrounds / Gray / Gray-03 (Xdark)
export const gray03 = "#323232";

// Backgrounds / Gray / Gray-04
export const gray04 = "#424242";

// Backgrounds / Gray / Gray-05 (Dark)
export const gray05 = "#535353";

// Backgrounds / Gray / Gray-06
export const gray06 = "#646464";

// Backgrounds / Gray / -Gray-07 (Base)
export const gray07 = "#767676";

// Backgrounds / Gray / Gray-08
export const gray08 = "#8a8a8a";

// Backgrounds / Gray / Gray-09 (Light)
export const gray09 = "#9e9e9e";

// Backgrounds / Gray / Gray-10
export const gray10 = "#b3b3b3";

// Backgrounds / Gray / Gray-11 (Xlight)
export const gray11 = "#c8c8c8";

// Backgrounds / Gray / Gray-12
export const gray12 = "#dbdbdb";

// Backgrounds / Gray / Gray-13
export const gray13 = "#efefef";

// Backgrounds / Gray / Gray-14 (Xxlight)
export const gray14 = "#f3f3f3";

// Table background dark color
export const grayTableBackground = "#111111";

// Transparents / Gray / 00-Gray-Light (70%)
export const grayLight = "rgba(118,118,118,0.7)";

export const backgroundLeftTop = "ghostwhite";

// Transparents / Gray / 01-Gray-Xlight (40%)
export const grayXLight = "rgba(118,118,118,0.4)";

// Transparents / Gray / 02-Gray-Xxlight (10%)
export const grayXXLight = "rgba(118,118,118,0.1)";

// medium light shade of gray
export const lightShadesGray = "#aaa";

// Backgrounds / Green / Green-00 (Xxdark)
export const green00 = "#121e00";

// Backgrounds / Green / Green-01
export const green01 = "#192a07";

// Backgrounds / Green / Green-02
export const green02 = "#28400f";

// Backgrounds / Green / Green-03 (Xdark)
export const green03 = "#385714";

// Backgrounds / Green / Green-04
export const green04 = "#4c731a";

// Backgrounds / Green / Green-05 (Dark)
export const green05 = "#61911f";

// Backgrounds / Green / Green-06
export const green06 = "#76af25";

// Backgrounds / Green / -Green-07 (Base)
export const green07 = "#8ccf2a";

// Backgrounds / Green / Green-08
export const green08 = "#a1d753";

// Backgrounds / Green / Green-09 (Light)
export const green09 = "#b4de74";

// Backgrounds / Green / Green-10
export const green10 = "#c6e593";

// Backgrounds / Green / Green-11 (Xlight)
export const green11 = "#d7edb2";

// Backgrounds / Green / Green-12
export const green12 = "#e5f3cd";

// Backgrounds / Green / Green-13
export const green13 = "#f3f9e8";

// Backgrounds / Green / Green-14 (Xxlight)
export const green14 = "#fbfdf7";

// Transparents / Green / 00-Green-Light (70%)
export const greenLight = "rgba(140,207,42,0.7)";

// Transparents / Green / 01-Green-Xlight (40%)
export const greenXLight = "rgba(140,207,42,0.4)";

// Transparents / Green / 02-Green-Xxlight (10%)
export const greenXXLight = "rgba(140,207,42,0.1)";

// Backgrounds / Indigo / Indigo-00 (Xxdark)
export const indigo00 = "#00071f";

// Backgrounds / Indigo / Indigo-01
export const indigo01 = "#07122c";

// Backgrounds / Indigo / Indigo-02
export const indigo02 = "#0f1e44";

// Backgrounds / Indigo / Indigo-03 (Xdark)
export const indigo03 = "#192b5e";

// Backgrounds / Indigo / Indigo-04
export const indigo04 = "#24397e";

// Backgrounds / Indigo / Indigo-05 (Dark)
export const indigo05 = "#30499f";

// Backgrounds / Indigo / Indigo-06
export const indigo06 = "#3c59c1";

// Backgrounds / Indigo / -Indigo-07 (Base)
export const indigo07 = "#4969e4";

// Backgrounds / Indigo / Indigo-08
export const indigo08 = "#6f7ee9";

// Backgrounds / Indigo / Indigo-09 (Light)
export const indigo09 = "#8e94ed";

// Backgrounds / Indigo / Indigo-10
export const indigo10 = "#a9abf1";

// Backgrounds / Indigo / Indigo-11 (Xlight)
export const indigo11 = "#c2c2f5";

// Backgrounds / Indigo / Indigo-12
export const indigo12 = "#d7d7f8";

// Backgrounds / Indigo / Indigo-13
export const indigo13 = "#ebedfb";

// Backgrounds / Indigo / Indigo-14 (Xxlight)
export const indigo14 = "#f7f9fd";

// Transparents / Indigo / 00-Indigo-Light (70%)
export const indigoLight = "rgba(73,105,228,0.7)";

// Transparents / Indigo / 01-Indigo-Xlight (40%)
export const indigoXLight = "rgba(73,105,228,0.4)";

// Transparents / Indigo / 02-Indigo-Xxlight (10%)
export const indigoXXLight = "rgba(73,105,228,0.1)";

// Backgrounds / Lime / Lime-00 (Xxdark)
export const lime00 = "#001f06";

// Backgrounds / Lime / Lime-01
export const lime01 = "#05290f";

// Backgrounds / Lime / Lime-02
export const lime02 = "#0c3c19";

// Backgrounds / Lime / Lime-03 (Xdark)
export const lime03 = "#145124";

// Backgrounds / Lime / Lime-04
export const lime04 = "#1f6930";

// Backgrounds / Lime / Lime-05 (Dark)
export const lime05 = "#2a833c";

// Backgrounds / Lime / Lime-06
export const lime06 = "#359e4a";

// Backgrounds / Lime / -Lime-07 (Base)
export const lime07 = "#41b957";

// Backgrounds / Lime / Lime-08
export const lime08 = "#65c470";

// Backgrounds / Lime / Lime-09 (Light)
export const lime09 = "#84d08a";

// Backgrounds / Lime / Lime-10
export const lime10 = "#a0dba3";

// Backgrounds / Lime / Lime-11 (Xlight)
export const lime11 = "#bbe5bd";

// Backgrounds / Lime / Lime-12
export const lime12 = "#d2efd4";

// Backgrounds / Lime / Lime-13
export const lime13 = "#e9f8eb";

// Backgrounds / Lime / Lime-14 (Xxlight)
export const lime14 = "#f6fdf8";

// Transparents / Lime / 00-Lime-Light (70%)
export const limeLight = "rgba(65,185,87,0.7)";

// Transparents / Lime / 01-Lime-Xlight (40%)
export const limeXLight = "rgba(65,185,87,0.4)";

// Transparents / Lime / 02-Lime-Xxlight (10%)
export const limeXXLight = "rgba(65,185,87,0.1)";

// Backgrounds / Orange / Orange-00 (Xxdark)
export const orange00 = "#1e0c00";

// Backgrounds / Orange / Orange-01
export const orange01 = "#2b1505";

// Backgrounds / Orange / Orange-02
export const orange02 = "#46210d";

// Backgrounds / Orange / Orange-03 (Xdark)
export const orange03 = "#622e10";

// Backgrounds / Orange / Orange-04
export const orange04 = "#853d12";

// Backgrounds / Orange / Orange-05 (Dark)
export const orange05 = "#a94d14";

// Backgrounds / Orange / Orange-06
export const orange06 = "#cf5d14";

// Backgrounds / Orange / -Orange-07 (Base)
export const orange07 = "#f66e13";

// Backgrounds / Orange / Orange-08
export const orange08 = "#fd853f";

// Backgrounds / Orange / Orange-09 (Light)
export const orange09 = "#ff9c62";

// Backgrounds / Orange / Orange-10
export const orange10 = "#ffb284";

// Backgrounds / Orange / Orange-11 (Xlight)
export const orange11 = "#ffc8a7";

// Backgrounds / Orange / Orange-12
export const orange12 = "#ffdbc5";

// Backgrounds / Orange / Orange-13
export const orange13 = "#ffeee5";

// Backgrounds / Orange / Orange-14 (Xxlight)
export const orange14 = "#fdf9f7";

// Transparents / Orange / 00-Orange-Light (70%)
export const orangeLight = "rgba(246,110,19,0.7)";

// Transparents / Orange / 01-Orange-Xlight (40%)
export const orangeXLight = "rgba(246,110,19,0.4)";

// Transparents / Orange / 02-Orange-Xxlight (10%)
export const orangeXXLight = "rgba(246,110,19,0.1)";

// Backgrounds / Pear / Pear-00 (Xxdark)
export const pear00 = "#1e1d00";

// Backgrounds / Pear / Pear-01
export const pear01 = "#2a2a07";

// Backgrounds / Pear / Pear-02
export const pear02 = "#42410e";

// Backgrounds / Pear / Pear-03 (Xdark)
export const pear03 = "#5d5a12";

// Backgrounds / Pear / Pear-04
export const pear04 = "#7c7815";

// Backgrounds / Pear / Pear-05 (Dark)
export const pear05 = "#9d9718";

// Backgrounds / Pear / Pear-06
export const pear06 = "#bfb71b";

// Backgrounds / Pear / -Pear-07 (Base)
export const pear07 = "#e3d91c";

// Backgrounds / Pear / Pear-08
export const pear08 = "#eade4f";

// Backgrounds / Pear / Pear-09 (Light)
export const pear09 = "#f0e472";

// Backgrounds / Pear / Pear-10
export const pear10 = "#f6e993";

// Backgrounds / Pear / Pear-11 (Xlight)
export const pear11 = "#f9efb2";

// Backgrounds / Pear / Pear-12
export const pear12 = "#fcf4cd";

// Backgrounds / Pear / Pear-13
export const pear13 = "#fdf9e8";

// Backgrounds / Pear / Pear-14 (Xxlight)
export const pear14 = "#fdfcf7";

// Transparents / Pear / 00-Pear-Light (70%)
export const pearLight = "rgba(227,217,28,0.7)";

// Transparents / Pear / 01-Pear-Xlight (40%)
export const pearXLight = "rgba(227,217,28,0.4)";

// Transparents / Pear / 02-Pear-Xxlight (10%)
export const pearXXLight = "rgba(227,217,28,0.1)";

// Backgrounds / Pink / Pink-00 (Xxdark)
export const pink00 = "#1e000a";

// Backgrounds / Pink / Pink-01
export const pink01 = "#280a14";

// Backgrounds / Pink / Pink-02
export const pink02 = "#3f1221";

// Backgrounds / Pink / Pink-03 (Xdark)
export const pink03 = "#58192f";

// Backgrounds / Pink / Pink-04
export const pink04 = "#75223f";

// Backgrounds / Pink / Pink-05 (Dark)
export const pink05 = "#942b50";

// Backgrounds / Pink / Pink-06
export const pink06 = "#b53461";

// Backgrounds / Pink / -Pink-07 (Base)
export const pink07 = "#d63d73";

// Backgrounds / Pink / Pink-08
export const pink08 = "#e06187";

// Backgrounds / Pink / Pink-09 (Light)
export const pink09 = "#e87f9c";

// Backgrounds / Pink / Pink-10
export const pink10 = "#f09cb1";

// Backgrounds / Pink / Pink-11 (Xlight)
export const pink11 = "#f5b8c6";

// Backgrounds / Pink / Pink-12
export const pink12 = "#f9d1da";

// Backgrounds / Pink / Pink-13
export const pink13 = "#fce9ee";

// Backgrounds / Pink / Pink-14 (Xxlight)
export const pink14 = "#fdf7f9";

// Transparents / Pink / 00-Pink-Light (70%)
export const pinkLight = "rgba(214,61,115,0.7)";

// Transparents / Pink / 01-Pink-Xlight (40%)
export const pinkXLight = "rgba(214,61,115,0.4)";

// Transparents / Pink / 02-Pink-Xxlight (10%)
export const pinkXXLight = "rgba(214,61,115,0.1)";

// Backgrounds / Red / Red-00 (Xxdark)
export const red00 = "#1e0002";

// Backgrounds / Red / Red-01
export const red01 = "#2a0805";

// Backgrounds / Red / Red-02
export const red02 = "#420e0b";

// Backgrounds / Red / Red-03 (Xdark)
export const red03 = "#5d110f";

// Backgrounds / Red / Red-04
export const red04 = "#7d1311";

// Backgrounds / Red / Red-05 (Dark)
export const red05 = "#9e1313";

// Backgrounds / Red / Red-06
export const red06 = "#c11014";

// Backgrounds / Red / -Red-07 (Base)
export const red07 = "#e50914";

// Backgrounds / Red / Red-08
export const red08 = "#f04c38";

// Backgrounds / Red / Red-09 (Light)
export const red09 = "#f9715a";

// Backgrounds / Red / Red-10
export const red10 = "#ff927d";

// Backgrounds / Red / Red-11 (Xlight)
export const red11 = "#ffb2a2";

// Backgrounds / Red / Red-12
export const red12 = "#ffcdc3";

// Backgrounds / Red / Red-13
export const red13 = "#ffe8e4";

// Backgrounds / Red / Red-14 (Xxlight)
export const red14 = "#fdf7f8";

// Transparents / Red / 00-Red-Light (70%)
export const redLight = "rgba(229,9,20,0.7)";

// Transparents / Red / 01-Red-Xlight (40%)
export const redXLight = "rgba(229,9,20,0.4)";

// Transparents / Red / 02-Red-Xxlight (10%)
export const redXXLight = "rgba(229,9,20,0.1)";

// Backgrounds / Violet / Violet-00 (Xxdark)
export const violet00 = "#08001e";

// Backgrounds / Violet / Violet-01
export const violet01 = "#110b2b";

// Backgrounds / Violet / Violet-02
export const violet02 = "#1d1643";

// Backgrounds / Violet / Violet-03 (Xdark)
export const violet03 = "#2a1f5d";

// Backgrounds / Violet / Violet-04
export const violet04 = "#3b297c";

// Backgrounds / Violet / Violet-05 (Dark)
export const violet05 = "#4c349d";

// Backgrounds / Violet / Violet-06
export const violet06 = "#5e3fbf";

// Backgrounds / Violet / -Violet-07 (Base)
export const violet07 = "#714be2";

// Backgrounds / Violet / Violet-08
export const violet08 = "#8c66e7";

// Backgrounds / Violet / Violet-09 (Light)
export const violet09 = "#a481ec";

// Backgrounds / Violet / Violet-10
export const violet10 = "#ba9cf1";

// Backgrounds / Violet / Violet-11 (Xlight)
export const violet11 = "#ceb8f5";

// Backgrounds / Violet / Violet-12
export const violet12 = "#dfd0f8";

// Backgrounds / Violet / Violet-13
export const violet13 = "#f0e9fb";

// Backgrounds / Violet / Violet-14 (Xxlight)
export const violet14 = "#f9f7fd";

// Transparents / Violet / 00-Violet-Light (70%)
export const violetLight = "rgba(113,75,226,0.7)";

// Transparents / Violet / 01-Violet-Xlight (40%)
export const violetXLight = "rgba(113,75,226,0.4)";

// Transparents / Violet / 02-Violet-Xxlight (10%)
export const violetXXLight = "rgba(113,75,226,0.1)";

// Backgrounds / White
export const white = "#FFFFFF";

// Transparents / White / 00-White-Light (70%)
export const whiteLight = "rgba(255,255,255,0.7)";

// Transparents / White / 01-White-Xlight (40%)
export const whiteXLight = "rgba(255,255,255,0.4)";

// Transparents / White / 02-White-Xxlight (10%)
export const whiteXXLight = "rgba(255,255,255,0.1)";

// Backgrounds / Yellow / Yellow-00 (Xxdark)
export const yellow00 = "#1e1400";

// Backgrounds / Yellow / Yellow-01
export const yellow01 = "#2c1e06";

// Backgrounds / Yellow / Yellow-02
export const yellow02 = "#47300d";

// Backgrounds / Yellow / Yellow-03 (Xdark)
export const yellow03 = "#64430f";

// Backgrounds / Yellow / Yellow-04
export const yellow04 = "#875a11";

// Backgrounds / Yellow / Yellow-05 (Dark)
export const yellow05 = "#ac7210";

// Backgrounds / Yellow / Yellow-06
export const yellow06 = "#d38a0c";

// Backgrounds / Yellow / -Yellow-07 (Base)
export const yellow07 = "#fba404";

// Backgrounds / Yellow / Yellow-08
export const yellow08 = "#ffb141";

// Backgrounds / Yellow / Yellow-09 (Light)
export const yellow09 = "#ffbf66";

// Backgrounds / Yellow / Yellow-10
export const yellow10 = "#ffcd89";

// Backgrounds / Yellow / Yellow-11 (Xlight)
export const yellow11 = "#ffdbaa";

// Backgrounds / Yellow / Yellow-12
export const yellow12 = "#ffe7c8";

// Backgrounds / Yellow / Yellow-13
export const yellow13 = "#fff4e6";

// Backgrounds / Yellow / Yellow-14 (Xxlight)
export const yellow14 = "#fdfbf7";

// Transparents / Yellow / 00-Yellow-Light (70%)
export const yellowLight = "rgba(251,164,4,0.7)";

// Transparents / Yellow / 01-Yellow-Xlight (40%)
export const yellowXLight = "rgba(251,164,4,0.4)";

// Transparents / Yellow / 02-Yellow-Xxlight (10%)
export const yellowXXLight = "rgba(251,164,4,0.1)";

// Primary Green color
export const primaryGreen = "#40BA56";

// TagChip Colors

//success
export const successTag = "#9FDCAA";

//progress
export const progressTag = "#8DE0F9";

//error
export const errorTag = "#FBB4C6";

//warning
export const warningTag = "#FCD181";

//warning
export const otherTag = "#C8ABFF";

// Wait task type button
export const blackish = "#1f1f1f";
export const gray15 = "#a5a5a5";

// User roles tag colors

//admin
export const roleAdmin = "#9FDCAA";

//readonly
export const roleReadOnly = "#DDDDDD";

//user
export const roleUser = "#C8ABFF";

//workflow-manager
export const roleWfManager = "#8DE0F9";

//workflow-manager
export const roleMetaManager = "#FCD181";

// New Sidebar colors
export const sidebarBlacky = "#060606";
export const sidebarGreyText = "#858585";
export const sidebarGreyDark = "#161616";
export const sidebarFaintGrey = "#DDDDDD";
export const sidebarGrey = "#494949";
export const sidebarBarelyPastWhite = "#F3F3F3";
export const sidebarVersion = "#9C9C9C";
export const sidebarUIVersion = "#494949";

// purple color in new theme
export const lightPurple = "#c8abff";

export const greyBorder = "#DDDDDD";
export const greyText = "#858585";
export const greyText2 = "#AFAFAF";

// colors for SearchEverything and UIModal
export const seGrey2 = "#AFAFAF";
// default modal backdropColor
export const defaultModalBackdropColor = "#AFAFAF";

// colors for tabs v1
export const tabsColor = "#494949";
export const tabActiveColor = "#060606";
export const tabBackground = "#DDDDDD";
export const tabsContainerBg = "#F3F3F3";

export const modalBackdropColor = "#090a11cc";
export const colorfullGradient =
  "linear-gradient(0.40turn,rgba(28, 177, 255,0.4), rgba(25, 118, 210,0.4), rgba(145, 87, 255,0.4), rgba(255, 106, 128,0.4));";
export const blueLight = "#0D94DB";
export const blueLightMode = "#1976D2";
export const darkBlueLightMode = "#1976D2";
export const lightBlueHoverBg = "#CAE0F5";
export const blueBackground = "#1CB1FF";
export const greyBg = "#252525";
export const primaryHoverBoxShadow = "#04386C";
export const secondaryHoverBoxShadow = "#095096";
export const tertiaryHoverBoxShadow = "#4D4D4D";
export const orkesBrandN200 = "#D7DCDD";
export const orkesBrandS600 = "#189ED3";
export const secondaryBlack = "#060606";

export const errorRed = "#D6423B";

// disabled input
export const lightGrey = "#ECECEC";
export const greenBackground = "#2e7d32";

export const lightGreyBackground = "#EFF0F0";
// cyan
export const cyan = "#00FFFF";
